<template>
  <div>
    <ModuleHeader>Reservas AYB</ModuleHeader>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col v-if="false" md="12" cols="6">
                <v-autocomplete v-model="Departamento" label="Punto Venta" :items="modulos">
                </v-autocomplete>
              </v-col>
              <v-col md="12" cols="6">
                <v-select v-model="depto" :items="departamentos" :menu-props="{ maxHeight: '400' }" item-text="Nombre"
                  item-value="Id" label="Departamentos restaurante" persistent-hint></v-select>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn v-if="depto" depressed @click="getAreas()" color="success">
                  Cargar Reservas
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="areas.length > 0">
      <v-col cols="12">
        <v-tabs v-model="tab">
          <v-tab>Mapa</v-tab>
          <v-tab>Lista</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <v-system-bar class="justify-end" height="35px"><v-btn v-if="false" text
                  @click="reservationValues"><span>{{
                    sendReservationValues
                      ? " Ocultar reservas en mapa"
                      : "Mostrar reservas en mapa"
                  }}</span><v-icon>mdi-map-clock-outline</v-icon></v-btn>
                <v-btn text @click="getAreas()"><span>Actualizar
                    reservas</span><v-icon>mdi-map-clock-outline</v-icon></v-btn>
                <v-btn text v-show="!drawer" @click="drawer = true"><span class="mr-1">Ver
                    reservas</span><v-icon>mdi-calendar-multiple-check</v-icon></v-btn></v-system-bar>
              <v-tabs v-if="areas.length > 0" dark>
                <template v-for="(area, index) in areas">
                  <v-tab :key="index">
                    {{ area.Nombre }}
                  </v-tab>
                </template>
                <template v-for="(areaMapa, index) in AreasData">
                  <v-tab-item :key="index">
                    <v-card flat>
                      <v-card-text>
                        <floorRestaurant :key="indexMapa" :editable="false" :roomData="areaMapa"
                          :mainReservas="reservasToMap" :mainInputDate="inputDate.format('YYYY-MM-DD')"
                          :contenedores="contenedores" />
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
              </v-tabs>
            </v-card>
            <NavigationDrawer v-model="drawer" :width="'40%'" style="z-index: 1; height: 100%">
              <BookingMesa :aybDepto="depto" :key="indexFormMesa" :Departamento="Departamento" :areas="areas"
                :AreasData="AreasData" :indexMapa="indexMapa" :mapas="mapas" :contenedores="contenedores"
                @inputDate-enviado="recibirInputDate" @changeFunction="changeFunction" @reloadBookings="getAreas">
                <div class="text-end mt-2">
                  <v-btn text @click="
                    drawer = false;
                  changeFunction('date');
                  " color="red"><span class="mr-1">Cerrar reservas</span><v-icon>mdi-close</v-icon></v-btn>
                </div>
              </BookingMesa>
            </NavigationDrawer>
          </v-tab-item>
          <v-tab-item>
            <uv-data-table :config="config" :data="reservations" :pageRows="15"></uv-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-col>

      <v-col cols="12"> </v-col>
    </v-row>
  </div>
</template>

<script>
import floorRestaurant from "./BookingMapsComponents/floorRestaurant.vue";
import BookingMesa from "./BookingMapsComponents/BookingMesa.vue";
import NavigationDrawer from "../../MainComponents/NavigationDrawer.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import moment from "moment";
export default {
  name: "BookingTable",
  components: {
    floorRestaurant,
    BookingMesa,
    NavigationDrawer,
    uvDataTable
  },
  props: ["hideMenu"],
  data() {
    return {
      tab: 0,
      Departamento: null,
      depto: null,
      reservations: [],
      indexMapa: 1,
      indexFormMesa: 0,
      departamentos: [],
      contenedores: [],
      mapas: [],
      areas: [],
      AreasData: [],
      inputDate: moment(),
      sendReservationValues: true,
      drawer: false,
      reservationArray: null,
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        rawText: "Reservas AYB",
        allowExport: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [

        ],
        fields: [
          {
            text: "Fecha",
            value: "fr",
          },
          {
            text: "Nombre",
            value: "cn",
          },
          {
            text: "Personas",
            value: "px",
          },
          {
            text: "Estatus",
            value: "et",
          },
          {
            text: "Mesa",
            value: "mesa",
          },
          {
            text: "Area",
            value: "area",
          },
          {
            text: "Telefono",
            value: "tl",
          },
          {
            text: "Nota",
            value: "nt",
          },

        ],
      },
    };
  },
  computed: {
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    reservasToMap() {
      let reservas = [];
      let sortedReserva = null;
      if (this.reservationArray) {
        sortedReserva = [];
        // Añadir la propiedad atrasada y extraer fecha y hora
        reservas = this.reservationArray.map((reserva) => {
          const reservaDate = moment(reserva.fr, "YYYY/MM/DD_HH:mm:ss");
          return {
            ...reserva,
            fecha: reservaDate.format("YYYY/MM/DD"),
            hora: reservaDate.format("HH:mm"),
          };
        });

        // Filtrar por la fecha ingresada (si hay) y añadir las atrasadas
        reservas = reservas.filter((reserva) => {
          return moment(reserva.fr, "YYYY/MM/DD").isSame(this.inputDate, "day");
        });
        reservas = reservas.filter((reserva) => {
          return (
            reserva.ms && reserva.et != "asignado" && reserva.et != "cancelado"
          );
        });
        // Ordenar las reservas por fecha y hora
        sortedReserva = this.$_.orderBy(
          reservas,
          (reserva) =>
            moment(
              reserva.fecha + " " + reserva.hora,
              "YYYY/MM/DD HH:mm"
            ).toDate(),
          "asc"
        );
      }
      return sortedReserva;
    },
  },
  methods: {
    recibirInputDate(inputDate) {
      this.inputDate = inputDate;
      this.indexMapa++;
    },
    async changeFunction(text) {
      if (text) {
        this.inputDate = moment();
      }
      await this.getReservas();
      this.reservationArray = this.reservationValues ? this.reservations : null;
      this.indexMapa++;
    },
    async reservationValues() {
      this.sendReservationValues = !this.sendReservationValues;
      if (this.sendReservationValues) {
        this.reservationArray = this.reservations;
        this.indexMapa++;
      } else {
        this.reservationArray = this.reservations;
        this.indexMapa++;
      }
    },
    async processAreas() {
      let Areas = [];
      this.AreasData = [];

      Areas = this.areas;

      Areas.forEach((area) => {
        this.mapas.forEach((mapa) => {
          if (mapa.Area == area.Id) {
            mapa.Mapa.forEach((item) => {
              let contenedor = this.$pgsHelper.getById(
                this.contenedores,
                "Id",
                item.id
              );
              if (contenedor) {
                if (contenedor.Estado.E == 1) {
                  item.Open = true;
                } else {
                  item.Open = false;
                }
              }
              item.contenedor = contenedor;
            });
            area.Mapa = mapa;
          }
        });
      });

      this.AreasData = Areas;
    },
    async getDepartamentosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Departamentos"
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
    async getContenedores() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Contenedores/" + this.depto
        );
      if (snapshot.exists()) {
        this.contenedores = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            toAdd.id = id;
            this.contenedores.push(toAdd);
          }
        });
      }
    },
    async getReservas() {
      let reservations = [];
      const equal =
        "D" + this.depto + "~Dreservado";
      let data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "AYB/Reservas",
        [
          this.$store.getters.getFirebaseApp.database.orderByChild("_I/test"),
          this.$store.getters.getFirebaseApp.database.equalTo(equal),
        ]
      );
      if (data.exists()) {
        let reservas = Object.entries(data.val());
        reservas.forEach((element) => {

          let area = "Sin Area"
          if (element[1].ms) {
            let contenedor = this.$pgsHelper.getById(
              this.contenedores,
              "Id",
              element[1].ms.id
            );
            console.log("contenedor", contenedor)
            if (contenedor) {
              const areaData = this.$pgsHelper.getById(this.areas, "Id", contenedor.Area);
              if (areaData) {
                area = areaData.Nombre;
              }
            }
          }


          reservations.push({ id: element[0], mesa: element[1].ms ? element[1].ms.nm : "Sin Mesa", area: area, ...element[1] });
        });

        this.reservations = this.$_.orderBy(reservations, "fr", "asc");
        console.log(this.reservations)
      }
    },
    async getAreas() {
      await this.getReservas();
      let Areas = [];
      this.mapas = [];
      let snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Areas/" + this.depto
        );
      if (snapshot.exists()) {
        Areas = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            toAdd.id = id;
            Areas.push(toAdd);
          }
        });
      }

      const firestore = this.$store.getters.getFirebaseApp.firestore;

      const data = await firestore.queryBuilder("AYB_Mapas", [
        firestore.where("Departamento", "==", this.depto),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let dataMapas = data.docs.map((doc) => {
        return { Id: doc.ref.id, ...doc.data() };
      });
      this.mapas = dataMapas;
      Areas.forEach((area) => {
        dataMapas.forEach((mapa) => {
          if (mapa.Area == area.Id) {
            area.Mapa = mapa;
          }
        });
      });
      this.areas = Areas;
      await this.getContenedores();
      await this.processAreas();
      this.reservationValues();
      this.getReservas()
      this.indexFormMesa++;
    },
    async getAccounts() {
      this.getAybCuentas = [];

      const startDate = new moment(this.input_date).format(
        "YYYY-MM-DD 00:00:00"
      );
      const endDate = new moment(this.input_date_final).format(
        "YYYY-MM-DD 23:59:59"
      );
      const startMlsc = new moment(startDate).valueOf();
      const endMlsc = new moment(endDate).valueOf();

      /*const end = endDate.replace(/.$/, (c) =>
          String.fromCharCode(c.charCodeAt(0) + 1)
        );*/
      let cuentas = [];

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AYB_Cuentas", [
        firestore.where("FechaCreacion", ">=", startMlsc),
        firestore.where("FechaCreacion", "<", endMlsc),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("DAYB", "==", this.depto),
      ]);
      cuentas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      this.getAybCuentas = cuentas;
    },
  },
  async mounted() {
    await this.getDepartamentosAB();
    await this.getReservas();
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
